import { registerPlugin, WebPlugin } from '@capacitor/core';

export interface FcmTokenPlugin {
  getToken(): Promise<{ token: string }>;
}

class FcmTokenWeb extends WebPlugin implements FcmTokenPlugin {
  async getToken(): Promise<{ token: string }> {
    throw new Error('FcmToken: disponible uniquement sur iOS/Android natif');
  }
}

/** iOS : token FCM Firebase (Capacitor Push envoie le token APNs, incompatible avec FCM côté serveur). */
export const FcmToken = registerPlugin<FcmTokenPlugin>('FcmToken', {
  web: () => new FcmTokenWeb(),
});
